import { Context } from 'effect';
import type { Effect } from 'effect';

import type {
  CookieAccessError,
  CookieGetError,
  CookieRemoveError,
  CookieSetError,
} from '../../data/error/cookies';
import { ContextTag } from '../context';

export type CookieOptions = {
  expires?: number | Date;
  path?: string;
  domain?: string;
  secure?: boolean;
  sameSite?: 'strict' | 'lax' | 'none';
  httpOnly?: boolean;
  maxAge?: number;
};

export type CookiesStoreService = {
  readonly get: (key: string) => Effect.Effect<string | null, CookieGetError | CookieAccessError>;
  readonly set: (
    key: string,
    value: string,
    options?: CookieOptions
  ) => Effect.Effect<void, CookieSetError | CookieAccessError>;
  readonly remove: (
    key: string,
    options?: Pick<CookieOptions, 'path' | 'domain'>
  ) => Effect.Effect<void, CookieRemoveError | CookieAccessError>;
  readonly has: (key: string) => Effect.Effect<boolean, CookieGetError | CookieAccessError>;
  readonly getAll: Effect.Effect<Record<string, string>, CookieAccessError>;
};

export class CookiesStore extends Context.Service<CookiesStore, CookiesStoreService>()(
  ContextTag.CookiesStore
) {}
